import React from "react";
import { TableRow, TableCell, LinearProgress } from "@mui/material";

export interface TableProgressRowProps {
  /** Number of columns to span */
  colSpan: number;
  /** Whether the loading bar is visible */
  loading: boolean;
}

/**
 * A reusable table row that shows a linear progress bar.
 * Typically used right under the TableHead.
 */
export const TableProgressRow: React.FC<TableProgressRowProps> = ({
  colSpan,
  loading,
}) => {
  return (
    <TableRow style={{ height: 2 }}>
      <TableCell
        colSpan={colSpan}
        style={{
          padding: 0,
          height: 2,
          borderBottom: "none",
        }}
      >
        <LinearProgress
          style={{
            height: 2,
            visibility: loading ? "visible" : "hidden",
          }}
        />
      </TableCell>
    </TableRow>
  );
};
